module.exports = __webpack_public_path__ + "img/guangzhou.277985ae.jpg";